<div class="map-container">
  <div id="map"></div>
</div>
<app-stop-departures></app-stop-departures>
<app-train-station></app-train-station>
